import { render } from "./post_status_modal.vue?vue&type=template&id=365216ee"
import script from "./post_status_modal.js?vue&type=script&lang=js"
export * from "./post_status_modal.js?vue&type=script&lang=js"

import "./post_status_modal.vue?vue&type=style&index=0&id=365216ee&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__